import React, { Fragment } from 'react';
import logo from "../images/Logo.png";



const Landing = () => {
    return (
        <Fragment>
            <div className="container mt-5 text-center">
                <h1>Welcome to Beyond Community Access</h1>
                {/* <img src={logo} alt="logo" /> */}
                <h2>Watch this space</h2>
            </div>
        </Fragment>
    );
}

export default Landing;